export default {
  filters: 'Filters:',
  btnReset: 'Reset',
  price: 'Price',
  privateTransfer: 'Private Transfer',
  wheelchar: 'Wheelchar',
};